import React, { useEffect, useState } from 'react'
import { classementAPI, domain, getCorrectListClub, getLongNameChamp } from '../variables';
import './PlayOffDown.css';
import './PlayOffProA.css';
import ContainerMatch from '../components/Playoffs/ContainerMatch';
import logoProAM from '../assets/proam.png'

import axios from "axios";

const PlayOffProA = ({championnat}) => {
    const [classement, setClassement] = useState(null);
    const [playoffsMatchs, setPlayoffsMatchs] = useState(null);
    const [tabulationActive, setTabulationActive] = useState(1);

    const updatePage = () => {
        setPlayoffsMatchs(null);
        setClassement(null);
        setTabulationActive(1);
        // A chaque changement de division on récupère le classement et les matchs de la division concernée
        getClassement();
        getPlayoffsMatchs();
    }

    useEffect(() => {
        updatePage()
    }, []);

    useEffect(() => {
        updatePage()
    }, [championnat]);

    useEffect(() => { 
    }, [tabulationActive])

    // fonction pour récupérer le classement
    const getClassement = async () => {
        const url = classementAPI.find(link => link.for === championnat)?.link;
        if (url) {
            axios
            .get(url, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                setClassement(res.data);
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    }

    // Fonction pour récupérer les matchs de playoffs
    const getPlayoffsMatchs = async () => {
        // on construit l'URL
        const url = `${domain}/server/getPODMatchs.php`;
        try {
            const response = await axios.post(url, {
                division: championnat,
                offOrDown: "off",
                withSets: true
            })

            if (response) {
                parseMatchs(response.data);
            }
        } 
        catch (error) {
            console.log(error);
        }
    }

    // Fonction pour regrouper les matchs ensemble car on récupère plusieurs lignes pour un même match selon le nombre de partie joués
    const parseMatchs = (matchs) => {
        let parsedMatchs = [];
        // on veut regrouper les mêmes matchs en y ajoutant les sets joués dans un seul objet
        matchs.forEach((match) => {
            const indexMatch = parsedMatchs.findIndex(p => p.renc_id === match.renc_id);
            if (indexMatch > -1) {
                // si on trouve le match et que des sets sont joués alors on rajoute uniquement les sets
                if (match.sets_data) {
                    parsedMatchs[indexMatch].sets_data.push(match.sets_data);
                }
            }
            else {
                // si on a pas déjà trouvé le match alors on le push dans le tableau
                parsedMatchs.push({
                    ...match,
                    sets_data: [match.sets_data]
                })
            }
        });
        setPlayoffsMatchs(parsedMatchs);
    }

    // Fonction pour récupérer un club en fonction de sa place dans le classement
    const getClubByRanking = (place) => {
        // s'il y a un classement
        if (classement) {
            // on récupère l'id du club à la place x
            const identifierClub = infoClassement(place-1, 'numero'); 
            // on récupère le nom du club
            const nameClub = infoClassement(place-1, "equipe")?.trim();

            // on récupère le club dans la bonne liste de division
            const club = getCorrectListClub(championnat).find(club => (club.identifier === identifierClub) || (club.title.trim() === nameClub)); 

            // on ajoute le classement à notre objet
            const clubWithRanking = {
                ...club,
                ranking: place
            }
            
            // on retourne le club
            return clubWithRanking;
        }

        // sinon null
        return null;
    }

    // Fonction pour récupérer le ranking d'un club
    const getRankingByClub = (club) => {
        if (classement) {
            let ranking = 0;
            classement.forEach((c) => {
                const name = c.equipe?.replace(/ +(?= )/g,'').trim();
                const identifier = c.numero?.trim();
                if (name === club?.title?.trim() || identifier === club?.identifier?.trim()) {
                    ranking = c.clt?.trim();
                }
            });
            return ranking;
        }
        return null;
    }

    // Fonction pour calculer le nombre de manche gagné au total dans une rencontre
    // utilisé en cas d'égalité pour pouvoir départager les deux équipes
    const determineWinnerByRounds = (setsAller, setsRetour) => {
        let homeRoundWon = 0;
        let awayRoundWon = 0;
        if (setsAller && setsRetour) {
            setsAller.forEach((sets) => {
                sets?.split(" ").forEach((point) => {
                    // set est un string
                    // Format d'un set exemple : -09 07 -10 -09
                    // lorsqu'il y a un - l'équipe à domicile perd le set
                    if (point[0] !== "-") {
                        homeRoundWon++; // si il n'y a pas de - alors le set est gagné
                    }
                    else {
                        awayRoundWon++; // s'il y a un - l'équipe extérieur gagne le set
                    }
                })
            });
            setsRetour.forEach((sets) => {
                sets?.split(" ").forEach((point) => {
                    // ici les équipes sont inversées puisque le domicile passe à l'extérieur
                    if (point[0] !== "-") {
                        awayRoundWon++; 
                    }
                    else {
                        homeRoundWon++;
                    }
                })
            });
            if (homeRoundWon === awayRoundWon) return "equal";
            return homeRoundWon > awayRoundWon ? "home" : "away";
        }
        return null;
    }

    // Fonction pour calculer le nombre de points gagnés au total dans une rencontre
    // utilisé en cas d'égalité pour pouvoir départager les deux équipes
    const determineWinnerByTotalPoints = (setsAller, setsRetour) => {
        let homePointsWon = 0;
        let awayPointsWon = 0;
        if (setsAller && setsRetour) {
            setsAller.forEach((sets) => {
                sets?.split(" ").forEach((point) => {
                    // set est un string
                    // Format d'un set exemple : -09 07 -10 -09
                    // lorsqu'il y a un - l'équipe à domicile perd le set
                    if (point[0] !== "-") {
                        homePointsWon += parseInt(point) >= 10 ? parseInt(point) + 2 : 11;
                        awayPointsWon += parseInt(point);
                    }
                    else {
                        const set = point.substring(1); // on retire le -
                        awayPointsWon += parseInt(set) >= 10 ? parseInt(set) + 2 : 11; 
                        homePointsWon += parseInt(set);
                    }
                })
            });
            setsRetour.forEach((sets) => {
                sets?.split(" ").forEach((point) => {
                    // ici les équipes sont inversées puisque le domicile passe à l'extérieur
                    if (point[0] !== "-") {
                        awayPointsWon += parseInt(point) >= 10 ? parseInt(point) + 2 : 11; 
                        homePointsWon += parseInt(point);
                    }
                    else {
                        const set = point.substring(1); // on retire le -
                        homePointsWon += parseInt(set) >= 10 ? parseInt(set) + 2 : 11; 
                        awayPointsWon += parseInt(set);
                    }
                })
            });
            if (homePointsWon === awayPointsWon) return "equal";
            return homePointsWon > awayPointsWon ? "home" : "away";
        }
        return null;
    }


    // Fonction pour récupérer le bon match
    const getRightMatch = (clubTop, clubBot, isRetour = false) => {
        const matchs = playoffsMatchs; // only playoff PRO A Messieurs
        if (matchs && clubTop && clubBot) {
            const dayMatchAller = [23, 25]; const dayMatchRetour = [24];
            const match = matchs.find((match) => {
                const day = parseInt(match.day_id);
                const nameDom = match.domicile?.replace(/ +(?= )/g,'').trim(); // on enlève les doubles espace / AMIENS STT  1 par exemple contient deux espaces
                const nameExt = match.exterieur?.replace(/ +(?= )/g,'').trim();
                const numDom = match.clubnum_1.trim();
                const numExt = match.clubnum_2.trim();
                //
                if (!isRetour) {
                    return dayMatchAller.includes(day) 
                    && 
                    ((nameDom === clubTop.title?.trim()  || numDom === clubTop.identifier?.trim()) || (numDom === clubBot.identifier?.trim() || nameDom === clubBot.title?.trim()))
                    &&
                    ((nameExt === clubTop.title?.trim() || numExt === clubTop.identifier?.trim()) || (numExt === clubBot.identifier?.trim() || nameExt === clubBot.title?.trim()))
                }
                else {
                    return dayMatchRetour.includes(day) 
                    && 
                    ((nameDom === clubTop.title?.trim() || numDom === clubTop.identifier?.trim()) || (numDom === clubBot.identifier?.trim() || nameDom === clubBot.title?.trim()))
                    &&
                    ((numExt === clubTop.identifier?.trim() || nameExt === clubTop.title?.trim()) || (numExt === clubBot.identifier?.trim() || nameExt === clubBot.title?.trim()))
                }
            });
            return match;
        }
        return null;
    }

    // fonction pour récupérer le gagnant d'un match grâce au classement des clubs
    const getWinnerOfMatch = (homeRanking, awayRanking, getPlace = false) => {
        if (homeRanking === null || awayRanking === null || homeRanking === undefined || awayRanking === undefined) return null;
        // on récupère les clubs avec le classement
        const homeClub = getClubByRanking(homeRanking);
        const awayClub = getClubByRanking(awayRanking);
        // on récupère les matchs
        const matchs = playoffsMatchs; // only playoff PRO A Messieurs
        // si on a les matchs
        if (matchs) {
            // on recherche le bon match
            // const match = matchs.find((match) => match?.domicile?.trim() === homeClub?.title?.trim() && match?.exterieur?.trim() === awayClub?.title?.trim());
            const match = getRightMatch(homeClub, awayClub, false)
            if (match && match?.winner !== null) {
                // const matchRetour = matchs.find((match) => match.domicile.trim() === awayClub?.title.trim() && match.exterieur.trim() === homeClub?.title.trim());
                const matchRetour = getRightMatch(homeClub, awayClub, true);
                if (matchRetour && matchRetour?.winner !== null) {
                    const winnerAller = match.winner;
                    const winnerRetour = matchRetour.winner;
                    // On regarde si on a le même gagnant pour les deux matchs
                    // la team à domicile passe à l'extérieur au match retour
                    if (winnerAller === "home" && winnerRetour === "away") {
                        let rightClub = getCorrectListClub(championnat).find(item => item.identifier.trim() === match.clubnum_1) || getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // la team extérieur passe à domicile au retour
                    if (winnerAller === "away" && winnerRetour === "home") {
                        let rightClub = getCorrectListClub(championnat).find(item => item.identifier.trim() === match.clubnum_2) || getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // en cas d'égalité on veut départager les équipes avec le nombre de manche gagné
                    // on commence par récupérer les sets
                    const setsAller = match.sets_data;
                    const setsRetour = matchRetour.sets_data;
                    // puis on calcule les manches gagnées
                    const winnerByRounds = determineWinnerByRounds(setsAller, setsRetour);
                    if (winnerByRounds === "home") {
                        let rightClub = getCorrectListClub(championnat).find(item => item.identifier.trim() === match.clubnum_1) || getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    if (winnerByRounds === "away") {
                        let rightClub = getCorrectListClub(championnat).find(item => item.identifier.trim() === match.clubnum_2) || getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // en cas d'égalité au nombre de manche gagné alors on départage avec les points
                    const winnerByTotalPoints = determineWinnerByTotalPoints(setsAller, setsRetour);
                    if (winnerByTotalPoints === "home") {
                        let rightClub = getCorrectListClub(championnat).find(item => item.identifier.trim() === match.clubnum_1) || getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    if (winnerByTotalPoints === "away") {
                        let rightClub = getCorrectListClub(championnat).find(item => item.identifier.trim() === match.clubnum_2) || getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    console.log("Egalité score final, manches et points totals")
                }
            }
        }
        return null;
    }

    // fonction pour récupérer le gagnant d'un match grâce de finale en aller simple
    const getWinnerOfFinal = (homeRanking, awayRanking, getPlace = false) => {
        if (homeRanking === null || awayRanking === null || homeRanking === undefined || awayRanking === undefined) return null;
        // on récupère les clubs avec le classement
        const homeClub = getClubByRanking(homeRanking);
        const awayClub = getClubByRanking(awayRanking);
        // on récupère les matchs
        const matchs = playoffsMatchs; // only playoff PRO A Messieurs
        // si on a les matchs
        if (matchs) {
            // on recherche le bon match
            // const match = matchs.find((match) => match?.domicile?.trim() === homeClub?.title?.trim() && match?.exterieur?.trim() === awayClub?.title?.trim());
            const match = getRightMatch(homeClub, awayClub, false)
            if (match && match?.winner !== null) {
                const winnerAller = match.winner;
                if (winnerAller === "home") {
                    let rightClub = getCorrectListClub(championnat).find(item => item.identifier.trim() === match.clubnum_1) || getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                    rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                    if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                    return rightClub;
                }
                if (winnerAller === "away") {
                    let rightClub = getCorrectListClub(championnat).find(item => item.identifier.trim() === match.clubnum_2) || getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                    rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                    if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                    return rightClub;
                }
                console.log("Le gagnant n'a pas pu être déterminé");
            }
        }
        return null;
    }

    const getEncounter = (homeClub, awayClub) => {
        const match = getRightMatch(homeClub, awayClub);
        const matchRetour = getRightMatch(homeClub, awayClub, true);
        return [
            match,
            matchRetour
        ];
    }

    const infoClassement = (index, value) => {
        if (classement) {
            return classement[index]?.[value];
        }
        return null;
    }

    return ( 
        <div className='playoffdown_page' style={{overflowX: 'hidden'}}>
            {/* // BANNIERE */}
            <div className={"top_banniere " + championnat}>
                <span>
                    <img src={logoProAM} alt="Logo pro" className="logo_p" />
                </span>
                <span className="top_banniere_title">
                    Playoffs {getLongNameChamp(championnat)}
                </span>
            </div>
            <div className='playoffdown_content' style={{paddingBottom: '0px'}}>
                <div className='playoffdown_matchs' style={{paddingTop: '20px', paddingBottom: '20px'}}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: 'fit-content', 
                    }}>
                        {/* MATCHS */}
                        <div style={{display: 'flex' , flexDirection: 'column', gap: 50}}>
                            <div style={{display: 'flex'}}>
                                <ContainerMatch
                                    clubTop={getClubByRanking(1)}
                                    clubBot={getClubByRanking(4)}
                                    getEncounter={getEncounter}
                                    championnat={championnat} 
                                    lineHeight={20} 
                                    lineWidth={280}
                                />
                            </div>
                            <div style={{display: 'flex'}}>
                                <ContainerMatch
                                    clubTop={getClubByRanking(3)}
                                    clubBot={getClubByRanking(2)}
                                    getEncounter={getEncounter}
                                    championnat={championnat} 
                                    lineHeight={20}
                                    lineWidth={280} 
                                />
                            </div>
                        </div>
                        {/* SEPARATEUR FINALE  */}
                        <div 
                            style={{
                                height: '58.2%',
                                width: 4,
                                backgroundColor: 'black'
                            }}
                        />
                        {/* FINALE */}
                        <ContainerMatch
                            clubTop={getWinnerOfMatch(1, 4)}
                            clubBot={getWinnerOfMatch(3, 2)}
                            getEncounter={getEncounter}
                            getWinner={getWinnerOfFinal}
                            invertedLine 
                            lineWidth={283}
                            championnat={championnat}
                            isFinal 
                            returnMatch={false}
                            displayMessage={"Finale Rouen 29 mai 2026"}
                        />
                    </div>
                        
                </div>
            </div>
        </div>
     );
}
 
export default PlayOffProA;